<template>
  <div>
    <b-alert 
      v-if="otherIds.length > 0" 
      variant="warning" 
      show
    >
      Dit kenmerk is al in gebruik bij de volgende documenten: {{ otherIds.join(', ') }}
    </b-alert>
    <b-alert 
      v-else 
      variant="success" 
      show
    >
      Document kenmerk is uniek
    </b-alert>
  </div>
</template>
<script>
import { serviceMixin } from '@/mixins/serviceMixin.js';    
    export default {
        name: 'DocumentKenmerk',
        components: {},
        mixins: [ serviceMixin],
        props: {
            relatieId: {
                type:Number,
                required: true,
            },
            kenmerk: {
                type: String,
                required: true,
            },
            currentId: {
                type: Number,
                required: true,
                default: 0,
            },
        },
        data() {
            return  {
                exists: false,
                ids: [],
            }
        },
        computed: {
            withCurrentId: function () {
                return this.ids.includes(this.currentId);
            },
            otherIds: function() {
                return this.ids.filter(id => id != this.currentId);
            }
        },
        watch: {
            relatieId: function () {
                this.bestaatKenmerk();
            },
            kenmerk: function () {
                if (this.kenmerk.length > 0 ) this.bestaatKenmerk();
            }
        },
        mounted () {
            this.bestaatKenmerk();
            
        },
        methods: {
            bestaatKenmerk: function async () {
            var url = `/afzender/${this.relatieId}/kenmerk/${this.kenmerk}`;
            this.get(url).then((response) => {
                this.exists =  response.data.status;
                this.ids = (response.data.ids || []);
            });
            },
        },
              
    }
</script>